import {
  convertDateToYYYYMMDDFormat,
  CustomDateRangePicker,
  FormFeedBack,
  PageWrapper,
  SimpleTableLoadingSkeleton,
  STATUSPAGE,
  TableVirtualized,
} from '@repo/ui';
import { useFormik } from 'formik';
import { ReportsGeneralFilters } from 'presentation/app/modules/Reports/components/reports-general-filters';
import { useStudentsIndividualWorkloadReport } from 'presentation/app/modules/Reports/hooks/useStudentsIndividualWorkloadReport';
import { useState } from 'react';
import { Card, Col, Input, Label, Row, Spinner } from 'reactstrap';
import * as Yup from 'yup';

import { makeStudentsIndividualWorkloadReportColumns } from '../../../common/columns/students/students-individual-workload-report-columns';

export const StudentsIndividualWorklodReport = () => {
  const [buttonSelectedSubmit, setButtonSelectedSubmit] =
    useState<string>(null);

  const {
    studentsCHI,
    requestGetStudentsIndividualWorkload,
    requestHandleStudentsIndividualWorkload,
    statusGet,
    statusHandle,
  } = useStudentsIndividualWorkloadReport();

  const todaysDate = new Date();
  const firstDayOfMonth = new Date(
    todaysDate.getFullYear(),
    todaysDate.getMonth(),
    1,
  );

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      unit: null,
      entity: null,
      groups: [],
      course: null,
      semester: null,
      starts: convertDateToYYYYMMDDFormat(firstDayOfMonth),
      ends: convertDateToYYYYMMDDFormat(todaysDate),
      query: null,
    },
    validationSchema: Yup.object({
      unit: Yup.object()
        .shape({
          label: Yup.string(),
          value: Yup.string(),
        })
        .nullable(),
      query: Yup.string().nullable(),
      entity: Yup.object()
        .shape({
          label: Yup.string(),
          value: Yup.string(),
        })
        .nullable(),
      groups: Yup.array().of(
        Yup.object()
          .shape({
            label: Yup.string(),
            value: Yup.string(),
          })
          .nullable(),
      ),
      course: Yup.object()
        .shape({
          label: Yup.string(),
          value: Yup.string(),
        })
        .nullable(),
      semester: Yup.object()
        .shape({
          label: Yup.string().nullable(),
          value: Yup.string().nullable(),
        })
        .nullable(),
      starts: Yup.date().nullable().required('Data inicial é obrigatório'),
      ends: Yup.date().nullable().required('Data final é obrigatório'),
    }),

    onSubmit: (values) => {
      const valuesToSubmit = {
        groups: values?.groups?.map((group) => group.value),
        type: buttonSelectedSubmit,
        ends: values.ends,
        starts: values.starts,
        entity: values?.entity?.value,
        course: values?.course?.value,
        semester: values?.semester?.value,
        curricularUnit: values?.unit?.value,
      };
      {
        buttonSelectedSubmit === '2' &&
          requestGetStudentsIndividualWorkload({
            ...valuesToSubmit,
          });
      }

      {
        buttonSelectedSubmit === '0' &&
          requestHandleStudentsIndividualWorkload(valuesToSubmit);
      }

      {
        buttonSelectedSubmit === '1' &&
          requestHandleStudentsIndividualWorkload(valuesToSubmit);
      }
    },
  });

  // const handleSearchRemote = useMemo(
  //   () =>
  //     debounce((search) => {
  //       requestGetStudentsIndividualWorkload({
  //         ...valuesToSubmit,
  //         search,
  //         type: '2',
  //       });
  //     }, 700),
  //   [],
  // );

  return (
    <PageWrapper title="Carga Horária Individual">
      <Col className="mb-3 border-0 d-flex align-items-end justify-content-between">
        <h4>Carga Horária Individual</h4>
      </Col>

      <Card>
        <ReportsGeneralFilters
          validation={validation}
          buttonsChildren={
            <div className="d-flex gap-2 justify-content-end align-content-end">
              <button
                id="search"
                type="submit"
                onClick={() => {
                  setButtonSelectedSubmit('2');
                }}
                className="btn btn-primary waves-effect waves-light"
                disabled={
                  statusGet === STATUSPAGE.LOADING ||
                  statusHandle === STATUSPAGE.LOADING
                }
              >
                {statusGet === STATUSPAGE.LOADING ? (
                  <Spinner size="sm">{['Carregando...']}</Spinner>
                ) : (
                  <>
                    Visualizar
                    <i className="ri-computer-line mx-2"></i>
                  </>
                )}
              </button>

              <button
                type="submit"
                id="export-pdf"
                onClick={() => {
                  setButtonSelectedSubmit('0');
                }}
                className="btn btn-light waves-effect waves-light"
                disabled={
                  statusHandle === STATUSPAGE.LOADING ||
                  statusGet === STATUSPAGE.LOADING
                }
              >
                {buttonSelectedSubmit === '0' &&
                statusHandle === STATUSPAGE.LOADING ? (
                  <Spinner size="sm">{['Carregando...']}</Spinner>
                ) : (
                  <>
                    Visualizar em PDF
                    <i className="las la-file-pdf mx-2"></i>
                  </>
                )}
              </button>
              <button
                id="export-excel"
                type="submit"
                onClick={() => {
                  setButtonSelectedSubmit('1');
                }}
                className="btn btn-light waves-effect waves-light"
                disabled={
                  statusHandle === STATUSPAGE.LOADING ||
                  statusGet === STATUSPAGE.LOADING
                }
              >
                {buttonSelectedSubmit === '1' &&
                statusHandle === STATUSPAGE.LOADING ? (
                  <Spinner size="sm">{['Carregando...']}</Spinner>
                ) : (
                  <>
                    Exportar para Excel
                    <i className="ri-file-excel-2-line mx-2"></i>
                  </>
                )}
              </button>
            </div>
          }
          inputsChildren={
            <Col sm={12} md={6} lg={3} className="mb-3">
              <Row>
                <Label htmlFor="initial-date" className="form-label">
                  Período
                </Label>
                <CustomDateRangePicker
                  placement="auto"
                  onDateChange={(start, ends) => {
                    validation.setFieldValue(
                      'starts',
                      convertDateToYYYYMMDDFormat(start),
                    );
                    validation.setFieldValue(
                      'ends',
                      convertDateToYYYYMMDDFormat(ends),
                    );
                  }}
                />
              </Row>
            </Col>
          }
        />

        {statusGet === STATUSPAGE.LOADING && <SimpleTableLoadingSkeleton />}

        {statusGet === STATUSPAGE.DONE && studentsCHI?.length > 0 && (
          <TableVirtualized
            columns={makeStudentsIndividualWorkloadReportColumns()}
            data={studentsCHI}
          />
        )}
      </Card>
    </PageWrapper>
  );
};
